module.exports = {"sld:ColorMapEntry":[{"color":"#0074ad","label":"< 3.00501","quantity":0.03005},{"color":"#9dc4b5","label":" 3.00501- 3.93507","quantity":0.03935},{"color":"#e6efc3","label":" 3.93507- 4.86066","quantity":0.04861},{"color":"#ffe89e","label":" 4.86066- 6.0452","quantity":0.06045},{"color":"#f5af7f","label":" 6.0452- 7.89545","quantity":0.07895},{"color":"#ed6d32","label":" 7.89545- 24.13482","quantity":0.24135}]}


//////////////////
// WEBPACK FOOTER
// ./static/bunSld_cropRisks/fxfl_raster/wheat_MME_1981_2016_lcr_90_return_20.json
// module id = VNj4
// module chunks = 171